import React from "react";
import DynamicHeadline from "./dynamicheadline";
export default function LpScripts() {
  return null;
}